import { render, staticRenderFns } from "./PlaceTile.vue?vue&type=template&id=18a7d24a&"
import script from "./PlaceTile.vue?vue&type=script&lang=js&"
export * from "./PlaceTile.vue?vue&type=script&lang=js&"
import style0 from "./PlaceTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlaceTile.vue"
export default component.exports